<template>
    <Button
        :type="isNotEmpty ? 'primary' : 'default'"
        :ghost="isNotEmpty"
        @click="onClick"
    >
        <span class="adv-text">筛选</span>
        <common-icon
            class="adv-icon"
            type="ios-funnel"
            :size="14"
            :color="isNotEmpty ? $theme.primaryColor : 'black'"
        ></common-icon>
        <smart-modal
            v-model="show"
            :width="800"
            :height="600"
            :maskClosable="false"
            :showHeader="false"
            :modalBeforeEnter="fetch"
            :modalBeforeBtnClick="btnHandlers"
            :buttons="buttons"
            @close-by-confirm="onConfirm"
        >
            <Form
                class="adv-form"
                ref="pInfo"
                :model="pInfo"
                :rules="rules"
                :label-width="200"
                label-position="top"
            >
                <FormItem label="房源编号" prop="houseName">
                    <Input
                        v-model="pInfo.houseName"
                        placeholder="请输入房源编号"
                        style="display: inline-block; width: 220px"
                    ></Input>
                    <span style="margin-left: 30px"
                        >房源编号规则：楼栋英文-楼层-房号。如C83,9621,BB523</span
                    >
                </FormItem>
                <FormItem
                    v-if="name === 'tenantsRent'"
                    label="当前交费状态"
                    prop="billStatus"
                >
                    <check-tag-group v-model="pInfo.billStatus" color="primary">
                        <check-tag
                            v-for="item in billStatusList"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                            >{{ item.text }}</check-tag
                        >
                    </check-tag-group>
                </FormItem>
                <FormItem
                    v-if="name === 'tenantsRent'"
                    label="租客状态"
                    prop="contractStatus"
                >
                    <check-tag-group
                        v-model="pInfo.contractStatus"
                        color="primary"
                        multiple
                    >
                        <check-tag
                            v-for="item in contractStatusList"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                            >{{ item.text }}</check-tag
                        >
                    </check-tag-group>
                </FormItem>
                <FormItem
                    v-if="name === 'tenantsHistory'"
                    label="居住状态"
                    prop="liveStatus"
                >
                    <check-tag-group v-model="pInfo.liveStatus" color="primary">
                        <check-tag
                            v-for="item in this.dict.liveStatus.toList()"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                            >{{ item.text }}</check-tag
                        >
                    </check-tag-group>
                </FormItem>
                <FormItem label="微信绑定状态" prop="isWxBind">
                    <check-tag-group v-model="pInfo.isWxBind" color="primary">
                        <check-tag
                            v-for="item in this.enums.IS_BIND.toList()"
                            class="adv-check-tag"
                            :name="item.id"
                            :key="item.id"
                            >{{ item.text }}</check-tag
                        >
                    </check-tag-group>
                </FormItem>
                <FormItem label="日期" prop="remark">
                    <div>
                        <div class="flex">
                            <check-tag-group
                                v-model="includeTime"
                                color="primary"
                                multiple
                                @on-change="onTimeChange"
                                ><check-tag
                                    class="adv-check-tag"
                                    name="createTime"
                                    >应付款日</check-tag
                                >
                            </check-tag-group>
                            <filter-date-range
                                v-show="includeTime.length"
                                :startDate.sync="pInfo.startDate"
                                :endDate.sync="pInfo.endDate"
                            ></filter-date-range>
                        </div>
                    </div>
                </FormItem>
            </Form>
        </smart-modal>
    </Button>
</template>

<script>
import FilterDateRange from '_vc/filter/filter-date-range'
import { type } from '_u/helper'

export default {
    name: 'TenantAdvSearch',
    components: {
        FilterDateRange,
    },
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        name: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            show: false,
            buttons: [
                { type: 'default', text: '重置', name: 'reset' },
                { type: 'primary', text: '确定', name: 'confirm' },
            ],
            btnHandlers: {
                reset: this.onReset,
            },
            dict: {
                billStatus: this.$dict.NULL,
                contractStatus: this.$dict.NULL,
                liveStatus: this.$dict.NULL,
            },
            enums: {
                IS_BIND: this.$enum.get('IS_BIND'),
            },
            pInfo: {
                houseName: '',
                billStatus: [],
                contractStatus: [],
                liveStatus: [],
                isWxBind: [],
                startDate: '',
                endDate: '',
            },
            includeTime: [],
        }
    },
    computed: {
        rules() {},
        isNotEmpty() {
            return Object.values(this.value).some((v) => v.length)
        },
        // 当前交费状态
        billStatusList() {
            return this.dict.billStatus
                .toList()
                .filter((v) => v.id == '1' || v.id == '2' || v.id == '5')
        },
        // 租客状态
        contractStatusList() {
            return this.dict.contractStatus
                .toList()
                .filter(
                    (v) =>
                        v.id == '1' ||
                        v.id == '3' ||
                        v.id == '4' ||
                        v.id == '11'
                )
        },
    },
    methods: {
        fetch(next) {
            return Promise.all([
                this.$dict.get([
                    'bill_status',
                    'contract_status',
                    'live_status',
                ]),
            ])
                .then((args) => {
                    var [group, user] = args

                    Object.assign(this.dict, group)
                    // 重新赋值
                    var val = this.value || {}
                    Object.keys(this.pInfo).forEach((k) => {
                        if (typeof val[k] !== 'undefined') {
                            this.pInfo[k] = val[k]
                        }
                    })
                    // 日期
                    this.includeTime =
                        this.pInfo.startDate || this.pInfo.endDate
                            ? ['time']
                            : []
                })
                .then(() => next())
        },
        onClick() {
            this.show = true
        },
        onConfirm() {
            this.$emit('input', this.pInfo)
            this.$emit('confirm', this.pInfo, this.getSelectedOptions())
        },
        onTimeChange(val) {
            if (val.length <= 0) {
                this.pInfo.startDate = ''
                this.pInfo.endDate = ''
            }
        },
        // 重置
        onReset(next, options) {
            options.closeModal = false
            Object.keys(this.pInfo).forEach((k) => {
                this.pInfo[k] = typeof this.pInfo[k] === 'object' ? [] : ''
            })
            next()
        },
        getSelectedOptions() {
            var options = []

            Object.keys(this.pInfo).forEach((k) => {
                var v = this.pInfo[k]

                // 日期区间
                // prettier-ignore
                if (k === 'startDate') {
                    var t1 = k,
                        t2 = 'endDate',
                        v1 = this.pInfo[t1],
                        v2 = this.pInfo[t2],
                        title = this.timeLabel

                    if(!v1 && !v2){
                        return
                    }

                    options.push({
                        id: `${v1}-${v2}`,
                        key: `${t1}-${t2}`,
                        text: `${v || '不限'}至${this.pInfo[t2] || '不限'}`,
                        label: `${title}`
                    })
                } else if (v) {
                    // prettier-ignore
                    switch (k) {
                        case 'houseName':
                            options.push({
                                id: v,
                                text: `${v}`,
                                key: k,
                                label: '房间编号'
                            })
                            break
                        case 'billStatus':
                            v.forEach(p => options.push({
                                id: p,
                                text: this.dict.billStatus.val(p),
                                key: k,
                                label: '当前交费状态'
                            }))
                            break
                        case 'contractStatus':
                            v.forEach(p => options.push({
                                id: p,
                                text: this.dict.contractStatus.val(p),
                                key: k,
                                label: '租客状态'
                            }))
                            break
                        case 'liveStatus':
                            v.forEach(p => options.push({
                                id: p,
                                text: this.dict.liveStatus.val(p),
                                key: k,
                                label: '居住状态'
                            }))
                            break
                        case 'isWxBind':
                            v.forEach(p => options.push({
                                id: p,
                                text: this.enums.IS_BIND.getName(p),
                                key: k,
                                label: '微信绑定状态'
                            }))
                            break
                    }
                }
            })

            return options
        },
    },
}
</script>

<style lang="less" scoped>
.adv {
    &-form {
        padding: 0 10px;
    }
    &-text {
        margin-right: 10px;
    }
    &-icon {
        vertical-align: -1px;
    }
    &-check-tag {
        padding: 2px 12px;
        height: auto;
    }
}
</style>
